import { Directive, Input, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[animation]',
})
export class IconAnimationDirective {
    @Input('start') start: string;
    @Input('end') end: string;
    @Input('type') type: string;
    @Input('speed') speed: number;
    private el: HTMLElement;
    constructor(private sourceEl: ElementRef) {
        this.el = this.sourceEl.nativeElement;
    }
    @HostListener('click') afterClick() {
        switch (this.type) {
            default:
                this.el.classList.add('rotate');
                if (this.el.innerHTML == this.start) {
                    this.el.innerHTML = this.end;
                } else {
                    this.el.innerHTML = this.start;
                }
                setTimeout(() => {
                    this.el.classList.remove('rotate');
                }, this.speed + 1);
        }
    }
}

@Directive({
    selector: '[animation2]',
})
export class IconAnimationDirective2 {
    @Input('start') start: string;
    @Input('end') end: string;
    @Input('type') type: string;
    @Input('speed') speed: number;
    private el: HTMLElement;
    constructor(private sourceEl: ElementRef) {
        this.el = this.sourceEl.nativeElement;
    }
    @HostListener('click') afterClick() {
        switch (this.type) {
            default:
                this.el.classList.add('rotate');
                if (this.el.innerHTML == this.start) {
                    this.el.innerHTML = this.end;
                } else {
                    this.el.innerHTML = this.start;
                }
                setTimeout(() => {
                    this.el.classList.remove('rotate');
                }, this.speed + 1);
        }
    }
}